import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const AddCommitteeModal = ({ open, onClose, onSave, editData }) => {
    const [form, setForm] = useState({
        committeeName: "",
        committeeDescription: "",
    });

    useEffect(() => {
        if (open) {
            setForm({
                committeeName: editData?.committeeName || "",
                committeeDescription: editData?.committeeDescription || "",
            })
        } else {
            setForm({ committeeName: "", committeeDescription: "" })
        }
    }, [open, editData]);

    if (!open) return null;

    return (
        <div className="admin-modal-overlay">
            <div className="admin-modal">
                <div className="admin-modal-header">
                    <div className="admin-modal-title">
                        {editData ? "Edit Committee" : "Add Committee"}
                    </div>
                    <button className="admin-modal-close" onClick={onClose}>
                        <IoClose />
                    </button>
                </div>

                <div className="admin-form-body">
                    <label className="admin-label">Committee Name <span>*</span></label>
                    <input
                        className="admin-input"
                        onChange={(e) => setForm({ ...form, committeeName: e.target.value })}
                        name="committeeName"
                        value={form.committeeName}
                        placeholder="Enter Committee Name"
                        required
                    />
                </div>

                <div className="admin-form-body">
                    <label className="admin-label">Committee Description</label>
                    <textarea
                        className="admin-input"
                        value={form.committeeDescription}
                        onChange={(e) => setForm({ ...form, committeeDescription: e.target.value })}
                        name="committeeDescription"
                        placeholder="Enter Committee Description"
                        rows={3}
                    />
                </div>

                <div className="admin-form-footer">
                    <button className="admin-btn-cancel" onClick={onClose}>
                        CANCEL
                    </button>
                    <button className="admin-btn-save" disabled={!form.committeeName.trim() || !form.committeeDescription.trim()} onClick={() => onSave(form)}>
                        SAVE
                    </button>
                </div>

            </div>
        </div>
    )
}

export default AddCommitteeModal;